
import { ICommonPensionInputs, SimplePensionFormOfPayment } from 'app/calcs/pensions/interfaces'
import * as moment from 'moment'

enum Local145FormOfPayment {
  lifeOnly = 1000,
  partialLumpSum = 1002
}

type OptionalValue = number | null

interface ILocal145PensionInputs extends ICommonPensionInputs {
  beginPaymentsAge: moment.Duration
  formOfPayment: Local145FormOfPayment | SimplePensionFormOfPayment
  hireDate: moment.Moment,
  statusCode: string,
  insideHours: number,
  residentialHours: number,
  teledataHours: number,
  totalPreviousYrsHours: number,
  insideCredits: number,
  insideCreditsValue: number,
  residentialCredits: number,
  residentialCreditsValue: number,
  teledataCredits: number,
  teledateCreditsValue: number,
  totalFutureCredits: number,
  futureService: OptionalValue,
  futureServiceValue: OptionalValue,
  activeWelfareDollarBank: OptionalValue,
  retireeWelfareDollarBank: OptionalValue,
  profitSharingBalance: number,
  futureServiceBucket: OptionalValue
}

export {
  ILocal145PensionInputs,
  Local145FormOfPayment
}



// WEBPACK FOOTER //
// ./src/app/calcs/customers/local145/interfaces/index.ts